module.exports = __webpack_public_path__ + "static/media/connected_data.46039889.svg";